import {inject, customElement, containerless} from "aurelia-framework";
// import {} from "";

@containerless()
// @inject()
@customElement("contacts-view-header")
export class ContactsHeader {



}
